/* eslint-disable react/display-name */
//React
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { DataTable as PrimeDataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
//CSS
import "./dataTable.scss";

/**
 * The app's data table (ASB-3953): PrimeReact's DataTable with our theme applied
 * once, here, instead of per view. Every PrimeReact prop passes through; only
 * the class name and a couple of defaults are added. Import `Column` from this
 * module too, so a view has one table import; `ColumnGroup` and `Row` build a
 * grouped header (`headerColumnGroup`, ASB-4377 column `group`).
 *
 *   import DataTable, { Column } from "../../components/table/dataTable";
 */
const DataTable = forwardRef(({ className, emptyMessage, compact, children, ...rest }, ref) => (
	<PrimeDataTable
		ref={ref}
		className={["as-datatable", compact ? "as-datatable--compact" : "", className ?? ""]
			.join(" ")
			.trim()}
		emptyMessage={emptyMessage ?? "No records found."}
		{...rest}
	>
		{children}
	</PrimeDataTable>
));

DataTable.propTypes = {
	className: PropTypes.string,
	emptyMessage: PropTypes.node,
	/** tighter cell padding for dense admin lists */
	compact: PropTypes.bool,
	children: PropTypes.node,
};

export { Column, ColumnGroup, Row };
export default DataTable;
